/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactPersonRequestParams
 */
export interface ContactPersonRequestParams {
    /**
     * 
     * @type {string}
     * @memberof ContactPersonRequestParams
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPersonRequestParams
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPersonRequestParams
     */
    mail: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPersonRequestParams
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactPersonRequestParams
     */
    mobile?: string;
    /**
     * 
     * @type {ContactPersonRequestParamsContactTypeEnum}
     * @memberof ContactPersonRequestParams
     */
    contactType: ContactPersonRequestParamsContactTypeEnum;
}


/**
 * @export
 */
export const ContactPersonRequestParamsContactTypeEnum = {
    Delivery: 'DELIVERY',
    Invoice: 'INVOICE',
    Contractual: 'CONTRACTUAL',
    Other: 'OTHER'
} as const;
export type ContactPersonRequestParamsContactTypeEnum = typeof ContactPersonRequestParamsContactTypeEnum[keyof typeof ContactPersonRequestParamsContactTypeEnum];


/**
 * Check if a given object implements the ContactPersonRequestParams interface.
 */
export function instanceOfContactPersonRequestParams(value: object): value is ContactPersonRequestParams {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('mail' in value) || value['mail'] === undefined) return false;
    if (!('contactType' in value) || value['contactType'] === undefined) return false;
    return true;
}

export function ContactPersonRequestParamsFromJSON(json: any): ContactPersonRequestParams {
    return ContactPersonRequestParamsFromJSONTyped(json, false);
}

export function ContactPersonRequestParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactPersonRequestParams {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'mail': json['mail'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'mobile': json['mobile'] == null ? undefined : json['mobile'],
        'contactType': json['contactType'],
    };
}

export function ContactPersonRequestParamsToJSON(json: any): ContactPersonRequestParams {
    return ContactPersonRequestParamsToJSONTyped(json, false);
}

export function ContactPersonRequestParamsToJSONTyped(value?: ContactPersonRequestParams | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'mail': value['mail'],
        'phone': value['phone'],
        'mobile': value['mobile'],
        'contactType': value['contactType'],
    };
}

